export const TRANSFER_MODES = [
  "airport_remote_transfer",
  "airport_getting_to",
  "airport_getting_from"
];

export const AIRPORT_GETTING_TO = "airport_getting_to";
export const AIRPORT_GETTING_FROM = "airport_getting_from";
export const REMOTE_TRANSFER = "airport_remote_transfer";
